import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
  clients_served: 250,
  pouches_produced_million: 12,
  average_delivery_days: 7,
  industries: 5,
};

const FACTORY =
  "https://images.unsplash.com/photo-1700727448686-b314cb5f9948?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80";

function useStats() {
  const [stats, setStats] = useState(FALLBACK);
  useEffect(() => {
    let on = true;
    axios
      .get(`${API}/stats`)
      .then((r) => {
        if (on && r.data) setStats(r.data);
      })
      .catch(() => {});
    return () => {
      on = false;
    };
  }, []);
  return stats;
}

export default function WhyUs() {
  const s = useStats();
  const stats = [
    { value: `${s.clients_served}+`, label: "Brands shipped" },
    { value: `${s.pouches_produced_million}M+`, label: "Pouches produced" },
    { value: `${s.average_delivery_days} Days`, label: "Avg. delivery" },
    { value: `${s.industries}+`, label: "Industries served" },
  ];

  return (
    <section
      data-testid="why-us-section"
      className="relative bg-[#0a1128] text-white py-20 md:py-28 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url(${FACTORY})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1128] via-[#0a1128]/85 to-[#0a1128]/55" />
      <div className="absolute inset-0 pk-noise opacity-40" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#F58220] mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#F58220]" />
              The Pacific Group edge
            </div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-black uppercase leading-[0.95] tracking-tighter">
              Twenty years of films.
              <br />
              <span className="text-[#F58220]">One</span> seven-day
              <br />
              promise.
            </h2>
            <p className="mt-6 max-w-2xl text-base md:text-lg text-white/75 leading-relaxed font-medium">
              PouchKart is built on top of Pacific Group’s two-decade
              manufacturing backbone — same factories that supply India’s
              biggest FMCG names, now opened up to startups and indie brands at
              MOQs that make sense.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-0 border border-white/15"
          data-testid="stats-grid"
        >
          {stats.map((st, i) => (
            <motion.div
              key={st.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className={`p-7 md:p-10 ${
                i < stats.length - 1
                  ? "border-b lg:border-b-0 lg:border-r border-white/15"
                  : ""
              } ${i < 2 ? "border-r lg:border-r border-white/15" : ""} ${
                i >= 2 ? "border-t lg:border-t-0 border-white/15" : ""
              }`}
            >
              <div className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-white">
                {st.value}
              </div>
              <div className="mt-3 text-[11px] font-bold uppercase tracking-[0.22em] text-[#F58220]">
                {st.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
